import React, { useMemo } from "react";
import clsx from "clsx";

import {
  getStudentAnswersByQuestion,
  getLessonFrom,
  getIssueFrom,
} from "../../../../libs/ActiveLearning";
import {
  IActiveLearningMaterialLessonsData,
  IActiveLearningStudentAnswers,
  IActiveLearningAllAnswers,
} from "../../../../state";
import styles from "../LessonsAnswerData.module.scss";

type Lesson11Pros = {
  materialCode: string;
  lessonNo: number;
  activeLearningMaterialLessons: IActiveLearningMaterialLessonsData[];
  activeLearningAnswers:
    | IActiveLearningStudentAnswers
    | IActiveLearningAllAnswers
    | null;
};

export const Lesson11: React.FC<Lesson11Pros> = ({
  materialCode,
  lessonNo,
  activeLearningMaterialLessons,
  activeLearningAnswers,
}) => {
  const activeLearningMaterialLessonsByCode = useMemo(() => {
    return activeLearningMaterialLessons.filter(
      data => data.code === materialCode,
    );
  }, [activeLearningMaterialLessons, materialCode]);

  const titleL11 = useMemo(() => {
    return getLessonFrom(activeLearningMaterialLessonsByCode, lessonNo)?.title;
  }, [activeLearningMaterialLessonsByCode, lessonNo]);

  const titleL11I1 = useMemo(() => {
    return getIssueFrom(activeLearningMaterialLessonsByCode, lessonNo, 1)
      ?.title;
  }, [activeLearningMaterialLessonsByCode, lessonNo]);

  const titleL11I2 = useMemo(() => {
    return getIssueFrom(activeLearningMaterialLessonsByCode, lessonNo, 2)
      ?.title;
  }, [activeLearningMaterialLessonsByCode, lessonNo]);

  const titleL11I3 = useMemo(() => {
    return getIssueFrom(activeLearningMaterialLessonsByCode, lessonNo, 3)
      ?.title;
  }, [activeLearningMaterialLessonsByCode, lessonNo]);

  const titleL11I4 = useMemo(() => {
    return getIssueFrom(activeLearningMaterialLessonsByCode, lessonNo, 4)
      ?.title;
  }, [activeLearningMaterialLessonsByCode, lessonNo]);

  const answersL11I1Q1 = useMemo(() => {
    const answers = getStudentAnswersByQuestion(
      materialCode,
      activeLearningAnswers,
      lessonNo,
      1,
      1,
    );

    return answers.length > 0
      ? answers.map(answer => answer.contents.value).join("")
      : "回答データがありません。";
  }, [materialCode, activeLearningAnswers, lessonNo]);

  const answersL11I2Q1 = useMemo(() => {
    const answers = getStudentAnswersByQuestion(
      materialCode,
      activeLearningAnswers,
      lessonNo,
      2,
      1,
    );

    return answers.length > 0
      ? answers.map(answer => answer.contents.value).join("")
      : "回答データがありません。";
  }, [materialCode, activeLearningAnswers, lessonNo]);

  const answersL11I3Q1 = useMemo(() => {
    const answers = getStudentAnswersByQuestion(
      materialCode,
      activeLearningAnswers,
      lessonNo,
      3,
      1,
    );

    return answers.length > 0
      ? answers.map(answer => answer.contents.value).join("")
      : "回答データがありません。";
  }, [materialCode, activeLearningAnswers, lessonNo]);

  const answersL11I4Q1 = useMemo(() => {
    const answers = getStudentAnswersByQuestion(
      materialCode,
      activeLearningAnswers,
      lessonNo,
      4,
      1,
    );

    return answers.length > 0
      ? answers.map(answer => answer.contents.value).join("")
      : "回答データがありません。";
  }, [materialCode, activeLearningAnswers, lessonNo]);

  return (
    <div className={styles.lesson}>
      <p className={styles.title}>
        Lesson{lessonNo < 10 ? `0${lessonNo}` : lessonNo} {titleL11}
      </p>
      <div className={styles.inner}>
        <div className={styles.work}>
          <p className={styles.no}>WORK01</p>
          <div className={styles.question}>
            <p className={styles.heading}>{titleL11I1}</p>
            <p className={clsx(styles.answer, styles.high)}>{answersL11I1Q1}</p>
          </div>
        </div>
        <div className={styles.work}>
          <p className={styles.no}>WORK02</p>
          <div className={styles.question}>
            <p className={styles.heading}>{titleL11I2}</p>
            <p className={clsx(styles.answer, styles.high)}>{answersL11I2Q1}</p>
          </div>
        </div>
        <div className={styles.work}>
          <p className={styles.no}>WORK03</p>
          <div className={styles.question}>
            <p className={styles.heading}>{titleL11I3}</p>
            <p className={clsx(styles.answer, styles.high)}>{answersL11I3Q1}</p>
          </div>
        </div>
        <div className={styles.work}>
          <p className={styles.no}>WORK04</p>
          <div className={styles.question}>
            <p className={styles.heading}>{titleL11I4}</p>
            <p className={clsx(styles.answer, styles.high)}>{answersL11I4Q1}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Lesson11;
